module.exports = __webpack_public_path__ + "static/media/download.37d6d287.svg";